import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30d3b27a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Comments ")
const _hoisted_2 = { class: "pb-2 border-bottom-1 border-300" }
const _hoisted_3 = { class: "container overflow-y-scroll overflow-x-hidden" }

import { Comment } from '@/models/comment';
import CommentList from './CommentList.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    comments: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "card" }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    subtitle: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.comments.length) + " Comments ", 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CommentList, {
          comments: __props.comments,
          brief: true
        }, null, 8, ["comments"])
      ])
    ]),
    _: 1
  }))
}
}

})